// extracted by mini-css-extract-plugin
export default {"content":"dbvBI","search-section":"p1Bvj"};